<div
  class="kgr-offCanvas kgr-offCanvas--safeArea"
  [class.is-open-left]="headerComponentState === 'mainMenuOpen'"
  [class.is-open-right]="headerComponentState === 'userMenuOpen'"
>
  <div class="offCanvasMenu mainMenu kgr-offCanvas__off kgr-offCanvas__off--fixed kgr-offCanvas__off--left">
    <kgr-main-menu></kgr-main-menu>
  </div>
  <div class="offCanvasMenu userMenu kgr-offCanvas__off kgr-offCanvas__off--fixed kgr-offCanvas__off--right">
    <kgr-user-menu [user]="user$ | async"></kgr-user-menu>
  </div>
  <div class="kgr-offCanvas__on">
    <div class="kgr-pageLayout kgr-pageLayout--sticky">
      <div class="kgr-pageLayout__header">
        <kgr-header [organization]="organization$ | async" [user]="user$ | async" (stateChange)="onHeaderStateChange($event)"></kgr-header>
      </div>
      <div class="kgr-pageLayout__main" #mainLayout>
        <div class="kgr-pageLayout__mainContent" [kgrLoading]="loading" [kgrLoadingBlocking]="true">
          <kgr-offline-message></kgr-offline-message>
          @if (loggedIn$ | async) {
            <kgr-active-wait-list-entries></kgr-active-wait-list-entries>
          }
          <router-outlet #o="outlet"></router-outlet>
        </div>
      </div>
      @if ((loggedIn$ | async) && (isScreenSmallAndDown$ | async)) {
        <kgr-tabbar class="kgr-pageLayout__footer"></kgr-tabbar>
      }
    </div>
  </div>
  <div class="kgr-offCanvas__backdrop kgr-clickable" (click)="closeMenus()"></div>
  <!-- <- backdrop must have class kgr-clickable to make iOS fire click events -->
</div>
<kgr-layer-login></kgr-layer-login>
<kgr-foreground-push-message></kgr-foreground-push-message>
<kgr-aks-for-push-notification-permissions></kgr-aks-for-push-notification-permissions>
